var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3564 63.5221C77.1637 56.9206 80 48.7915 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C48.4294 80 56.2497 77.3926 62.6986 72.9404L72.7229 76.2297C74.0508 76.6654 75.339 75.4692 75.0028 74.1128L72.4422 63.7836C72.4196 63.6924 72.3908 63.6052 72.3564 63.5221Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_5725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2743 50.6741C55.0096 50.6741 56.4164 49.2642 56.4164 47.525C56.4164 45.7858 55.0096 44.3759 53.2743 44.3759C51.5389 44.3759 50.1321 45.7858 50.1321 47.525C50.1321 49.2642 51.5389 50.6741 53.2743 50.6741Z",
    fill: "#0D0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.44 50.6742C31.1754 50.6742 32.5822 49.2642 32.5822 47.525C32.5822 45.7858 31.1754 44.3759 29.44 44.3759C27.7047 44.3759 26.2979 45.7858 26.2979 47.525C26.2979 49.2642 27.7047 50.6742 29.44 50.6742Z",
    fill: "#0D0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4105 54.231H53.7009V58.609H59.4105V54.231Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7008 54.2308H20.9761C20.6313 54.2308 20.3247 53.962 20.2864 53.6163V58.6089H53.7008V54.2308Z",
    fill: "#117BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2865 53.5396V42.9401H15.4199V53.7701C15.4199 56.4584 17.5658 58.609 20.2482 58.609H20.2865V53.6164C20.2865 53.578 20.2865 53.578 20.2865 53.5396Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4199 37.679V42.9404H20.2865V37.9094C20.2865 37.5638 20.5547 37.2565 20.8996 37.2181H15.4582C15.4199 37.3718 15.4199 37.5254 15.4199 37.679Z",
    fill: "#0092C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0182 32.8397C17.6041 32.9549 15.6498 34.8367 15.4583 37.2178H20.8996C20.9379 37.2178 20.9379 37.2178 20.9762 37.2178H55.0038V32.8397H20.0182Z",
    fill: "#0ED6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9653 32.8397V37.2178H60.0189C60.3661 37.2178 60.6747 37.4866 60.7133 37.8323V32.8397H54.9653Z",
    fill: "#0CC4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9819 32.8397H60.7136V37.8323C60.7136 37.8707 60.7136 37.8707 60.7136 37.9091V53.0019H65.5802V37.6787C65.5419 35.0672 63.5109 32.9549 60.9819 32.8397Z",
    fill: "#13E0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8292 26.597V31.955H41.6302V26.5202C42.8181 26.1362 43.6994 25.0992 43.6994 23.8319C43.6994 22.2573 42.3199 20.99 40.5956 20.99C38.9095 20.99 37.4917 22.2573 37.4917 23.8319C37.53 25.1761 38.5263 26.2898 39.8292 26.597Z",
    fill: "#01AAE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_5725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.16,
    height: 37.6191,
    fill: "white",
    transform: "translate(15.4199 20.99)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInBubble);
export default __webpack_public_path__ + "static/media/LogoInBubble.51a07382d139bd8433fb67c0b67fc9fa.svg";
export { ForwardRef as ReactComponent };